import { Badge } from '@/components/ui/Badge'
import { X } from 'lucide-react'

interface FilterPillProps {
  label: string
  onRemove?: () => void
  className?: string
}

export default function FilterPill({
  label,
  onRemove,
  className = '',
}: FilterPillProps) {
  const classes = `bg-primary/20 text-primary-foreground border-primary/30 hover:bg-primary/30 transition-colors cursor-pointer text-xs px-2 py-1 gap-1 ${className}`.trim()
  
  return (
    <Badge 
      variant="secondary" 
      className={classes}
    >
      <span>{label}</span>
      {onRemove && (
        <button
          onClick={onRemove}
          className="hover:bg-primary-foreground/20 rounded-full p-0.5 transition-colors"
          aria-label={`Remove ${label}`}
        >
          <X className="w-3 h-3" />
        </button>
      )}
    </Badge>
  )
}
